// extracted by mini-css-extract-plugin
module.exports = {"cardsGridLayout":"styles_cardsGridLayout__ztQI4","voucherGrid":"styles_voucherGrid__3eC4y"};